module.exports = "/_next/static/files/e8d08a7fba9559b62e8f37c780a079cf.jpg";